import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WizardComponent } from '../wizard/wizard.component';
import { AssessContributionToCostsComponent } from './apportionment/assess-contribution-to-costs/assess-contribution-to-costs.component';
import { ActivityListingComponent } from './exposure/activity-listing/activity-listing.component';
import { OutlineExposureToDustComponent } from './exposure/outline-exposure-to-dust/outline-exposure-to-dust.component';
import { EstablishBreachOfDutyComponent } from './investigation/establish-breach-of-duty/establish-breach-of-duty.component';
import { EstablishCausationComponent } from './investigation/establish-causation/establish-causation.component';
import { RadiologicalProgressionPleuralThickeningComponent } from './radiological-progression-pleural-thickening/radiological-progression-pleural-thickening.component';
import { RadiologicalProgressionChartPleuralComponent } from './radiological-progression-chart/radiological-progression-chart-pleural.component';

const routes: Routes = [
  {
    path: 'apportionment/assess-contribution-to-costs/:claimId/:taskId',
    component: WizardComponent,
  },
  {
    path: 'exposure/outline-exposure-to-dust/:claimId/:taskId',
    component: ActivityListingComponent,
  },
  {
    path: 'exposure/outline-exposure-to-dust/addActivity/:claimId/:taskId',
    component: OutlineExposureToDustComponent,
  },
  {
    path: 'exposure/outline-exposure-to-dust/editActivity/:claimId/:taskId/:activityId',
    component: OutlineExposureToDustComponent,
  },
  {
    path: 'investigation/establish-breach-of-duty/:claimId/:taskId',
    component: EstablishBreachOfDutyComponent,
  },
  {
    path: 'investigation/establish-causation/:claimId/:taskId',
    component: EstablishCausationComponent,
  },
  {
    path: 'radiological-progression/create-chart/:claimId',
    component: RadiologicalProgressionPleuralThickeningComponent,
  },
  {
    path: 'radiological-progression/edit-chart/:claimId/:radProgressionId',
    component: RadiologicalProgressionPleuralThickeningComponent,
  },
  {
    path: 'radiological-progression/view-chart/:claimId/:radProgressionId/:title',
    component: RadiologicalProgressionChartPleuralComponent,
  },
]


@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
  
})
export class PleuralthickeningRoutingModule { }
